module.exports = __webpack_public_path__ + "coin_LUNA.png?736137520a68d49f7dfba7e21d87e8f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_LUNA.png
// module id = 1121
// module chunks = 2